"use strict";
// (C) 2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.withBubble = void 0;
var tslib_1 = require("tslib");
var Bubble_1 = require("./Bubble");
var BubbleHoverTrigger_1 = require("./BubbleHoverTrigger");
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
/**
 * @internal
 */
function withBubble(WrappedComponent) {
    var ResultComponent = function (props) {
        var _a = props.showBubble, showBubble = _a === void 0 ? true : _a, _b = props.alignPoints, alignPoints = _b === void 0 ? [{ align: "cr cl" }] : _b, bubbleTextId = props.bubbleTextId, triggerClassName = props.triggerClassName, wrappedComponentProps = tslib_1.__rest(props, ["showBubble", "alignPoints", "bubbleTextId", "triggerClassName"]);
        var intl = react_intl_1.useIntl();
        if (!showBubble || !bubbleTextId) {
            return react_1.default.createElement(WrappedComponent, tslib_1.__assign({}, props));
        }
        var bubbleText = intl.formatMessage({ id: bubbleTextId });
        return (react_1.default.createElement(BubbleHoverTrigger_1.BubbleHoverTrigger, { className: triggerClassName },
            react_1.default.createElement(WrappedComponent, tslib_1.__assign({}, wrappedComponentProps)),
            react_1.default.createElement(Bubble_1.Bubble, { alignPoints: alignPoints },
                react_1.default.createElement("div", null, bubbleText))));
    };
    return ResultComponent;
}
exports.withBubble = withBubble;
//# sourceMappingURL=withBubble.js.map